import React from 'react'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
// import logoCenec from '../assets/cenec-logo.png';
// import logoChorotega from '../assets/chorotega-logo.svg';
import logoCenec from '../assets/cenec_2.png';
import logoChorotega from '../assets/chorotega_2.png';
import moment from 'moment/moment';
import html2canvas from 'html2canvas';
 

export const TransactionDetail = ({ data, entrepreneur, detailData }) => {
  moment.locale()
  const handleDownloadImage = () => {
    const card = document.getElementById('cardDetail');
    let opt = {
      // allowTaint: true
    }
    html2canvas(card, opt).then(function (canvas) {
      const link = document.createElement('a');
      link.download = 'comprobante-transaccion.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  }
  return (
    <>
      <Container>
        <Row>
          <Col className='mt-5 d-flex justify-content-center mb-3' md={12}>
            <Button variant='success' onClick={handleDownloadImage}>
              <i className="bi bi-cloud-arrow-down-fill me-2"></i> 
              Descargar
            </Button>
          </Col>
        </Row>

      </Container>

      <Container className='d-flex justify-content-center' style={{ 'maxWidth': '500px' }}>
        <Card id='cardDetail'>
          <Card.Header> 
          
            <h1 className='fs-2 fw-normal text-center text-success'>
              <i className="bi bi-check-circle fs-1"></i> 
              <br />
              {data.message}
            </h1>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="12">
                <div className="table-responsive">
                  <table className='table border-success' >
                    <tbody>
                      <tr>
                        <th>Comercio</th>
                        <td>{entrepreneur.entrepreneurship_name || entrepreneur.pyme_name}</td>
                      </tr>
                      <tr>
                        <th>Referencia</th>
                        <td>{detailData.correlative}</td>
                      </tr>
                      <tr>
                        <th>Fecha y hora</th>
                        <td>{moment(new Date()).format("DD-MM-YYYY H:m:a")}</td>
                      </tr>
                      <tr>
                        <th>Titular Tarjeta</th>
                        <td>{detailData.cardholder}</td>
                      </tr>
                      <tr>
                        <th>Tarjeta:</th>
                        <td>**** **** **** {detailData.number}</td>
                      </tr>
                      <tr>
                        <th>Correo:</th>
                        <td>{detailData.email}</td>
                      </tr>
                      <tr>
                        <th>Monto:</th>
                        <td>HNL {data.data.transaction_amount.toLocaleString("en-US")}</td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </Col>
            </Row>

          </Card.Body>
          <Card.Footer className='white-bg-color '>
            <Row className='cenec-bg-color mx-1 p-3 rounded-1'>
              <Col md={12}>
                <div className='d-flex justify-content-center mt-3'>
                  <img alt="Logo CENEC" className='img-comprobante-cenec' src={logoCenec}/>
                </div>
              </Col>
              <Col xs={12}>
                <div className='hl'></div>
              </Col>
              <Col md={12}>
                  <div className='d-flex justify-content-center mb-3'>
                    <img alt="Logo Cooperativa Chorotega" className='img-comprobante' src={logoChorotega}/>
                  </div>
              </Col>
            </Row>
          </Card.Footer>
        </Card>
        <hr />
      </Container>
    </>
  )
}
